import React, { useEffect, useState } from "react";
import "./Contact.css";
import { getDownloadURL, ref as storageRef } from "firebase/storage";
import { storage, db } from "../../firebase";
import { ref as dbRef, push, set } from "firebase/database";

export type ContactEmailInfo = {
    email: string;
    name: string;
    message: string;
};
const defaultContactEmailInfo: ContactEmailInfo = {
    name: "",
    email: "",
    message: "",
};
async function sendEmail(emailInfo: ContactEmailInfo) {
    const collectionsRef = dbRef(db, "messages");
    const newDocRef = push(collectionsRef);
    await set(newDocRef, emailInfo);
}

export default function Contact() {
    document.title = "Tomas Ordonez - Contact";

    // Fetch image url
    const [imageUrl, setImageUrl] = useState<string | null>(null);
    useEffect(() => {
        const fetchImageUrl = async () => {
            try {
                const url = await getDownloadURL(storageRef(storage, "Photography/Portugal/lisboa-house2.jpg"));
                setImageUrl(url);
            } catch (error) {
                console.error("Error: Failed to fetch contact page main image: ", error);
            }
        };
        fetchImageUrl();
    }, []);

    // Form
    const [oldName, setOldName] = React.useState<string>("");
    const messageRef = React.useRef<HTMLTextAreaElement | null>(null);
    const [contactEmailInfo, setContactEmailInfo] = React.useState<ContactEmailInfo>(defaultContactEmailInfo);
    const onChange = (e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setContactEmailInfo((v) => ({ ...v, [name]: value }));
    };

    // Notification
    const [notify, setNotify] = React.useState<"error" | "success" | false>(false);
    const Notification = (): React.JSX.Element => {
        setTimeout(() => {
            setNotify(false);
        }, 7000);
        return (
            <div
                className="notification"
                style={{
                    backgroundColor: notify === "success" ? "#9de0af" : "#e07070",
                }}
            >
                {notify === "success"
                    ? "Sent. Thank you for your message " + oldName + "!"
                    : "Error: The message failed to send, try again later."}
            </div>
        );
    };

    return (
        <div className="contact-page">
            <div className="email-form-page">
                {imageUrl && <img src={imageUrl} alt="contact-side" draggable={false} />}

                <form
                    className="email-form"
                    onSubmit={async (e) => {
                        e.preventDefault();
                        try {
                            if (contactEmailInfo) {
                                console.log("sending...");
                                await sendEmail(contactEmailInfo);
                                console.log("done...?");
                                setNotify("success");
                                setOldName(contactEmailInfo.name);
                                setContactEmailInfo(defaultContactEmailInfo);
                            }
                        } catch (error) {
                            setNotify("error");
                            console.error("Error: Failed to send message: ", error);
                        }
                    }}
                >
                    <table>
                        <tr>
                            <td>
                                <input
                                    autoComplete="off"
                                    className="name-input input-item"
                                    value={contactEmailInfo.name}
                                    type="text"
                                    placeholder="Name"
                                    name="name"
                                    onChange={onChange}
                                    required
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <input
                                    autoComplete="off"
                                    className="email-input input-item"
                                    value={contactEmailInfo.email}
                                    type="text"
                                    placeholder="Email"
                                    name="email"
                                    onChange={onChange}
                                    required
                                />
                            </td>
                        </tr>
                        <tr>
                            <td className="message-td" onClick={() => messageRef.current?.focus()}>
                                <textarea
                                    className="message-input input-item"
                                    value={contactEmailInfo.message}
                                    ref={messageRef}
                                    placeholder="Message"
                                    name="message"
                                    onChange={onChange}
                                    required
                                />
                            </td>
                        </tr>
                    </table>

                    <button type="submit">Send Message</button>
                    {notify && <Notification />}
                </form>
            </div>
        </div>
    );
}
